/**
 * Offline session bookkeeping (ADR-0021): remember when we last reached the
 * server; after `offlineReauthDays` without contact the user must sign in
 * online again (drafts are kept, but locked).
 */
import { offlineSessionValid } from '@sss/sync';

const LAST_CONTACT = 'sss.lastServerContact';

export function markServerContact(now = Date.now()): void {
  try {
    localStorage.setItem(LAST_CONTACT, String(now));
  } catch {
    /* storage unavailable */
  }
}

export function lastServerContact(): number | null {
  try {
    const v = localStorage.getItem(LAST_CONTACT);
    return v ? Number(v) : null;
  } catch {
    return null;
  }
}

export function isOfflineSessionValid(offlineReauthDays: number, now = Date.now()): boolean {
  const last = lastServerContact();
  if (last === null) return false;
  return offlineSessionValid(last, now, offlineReauthDays);
}

export function clearServerContact(): void {
  try {
    localStorage.removeItem(LAST_CONTACT);
  } catch {
    /* ignore */
  }
}
